export class ValidationHelper {
    /**
     * It checks if the value is a valid URL
     * @param {string} value - The value to be validated.
     * @returns A boolean value.
     */
    static isValidUrl(value) {
        // eslint-disable-next-line no-useless-escape
        return (/^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/g.test(value));
    }
    /**
     * It checks if the property is not undefined and not null
     * @param {any} property - any
     * @returns a boolean value.
     */
    static existProperty(property) {
        return typeof property !== 'undefined' && property !== null;
    }
    /**
     * If the type of the property is the same as the type expected,
     * return true, otherwise return false.
     * @param {any} property - any - The property to check the type of.
     * @param {string} typeExpected - The type of the property you want to check.
     * @returns A boolean value.
     */
    static sameTypeProperty(property, typeExpected) {
        return typeof property === typeExpected.toLocaleLowerCase();
    }
}
//# sourceMappingURL=validationHelpers.js.map